import React from "react";
import { Link } from "react-router-dom";
import Icon from "../icons/Icons";
import { openCalendly, IQ_LISTING } from "../../lib/calendly";
import APN_BADGE from "../../assets/images/apn-badge.png";
import "./Splash.css";

const services = [
  "Monthly Cloud Management",
  "Cloud Architecture & Infrastructure Design",
  "DevOps Automation & CI/CD",
  "Compliance Readiness (HIPAA & SOC2)",
  "AWS Marketplace Integration",
  "FinOps & Cost Optimization",
];

const Splash = () => {
  return (
    <section id="hero" className="blueprint">
      <div className="container hero-grid">
        <div className="hero-copy">
          <p className="eyebrow">aws select consulting partner</p>
          <h1 className="h1">
            Elevate your business with{" "}
            <span className="hero-accent">modern cloud solutions</span>
          </h1>
          <p className="hero-sub">
            We partner with ambitious companies to design, build, and manage
            cloud infrastructures that scale with your business needs. Our
            expert team delivers reliable AWS solutions on time and within
            budget.
          </p>

          <ul className="hero-services">
            {services.map((service) => (
              <li key={service}>
                <Icon name="check" size={15} strokeWidth={2.2} />
                {service}
              </li>
            ))}
          </ul>

          <div className="hero-actions">
            <button className="btn btn-primary" onClick={openCalendly}>
              <Icon name="calendar" size={16} />
              Schedule free consultation
            </button>
            <div className="hero-actions-row">
              <Link to="/services" className="btn btn-ghost">
                Explore our services
                <Icon name="arrowRight" size={16} />
              </Link>
              <Link to="/products" className="btn btn-ghost">
                Explore our products
                <Icon name="layers" size={16} />
              </Link>
            </div>
          </div>
        </div>

        <div className="hero-visual">
          <div className="diagram-card">
            <div className="diagram-head">
              <span>{"// secure ai architecture"}</span>
              <span>isolated by design</span>
            </div>
            <svg
              className="diagram"
              viewBox="0 0 460 340"
              role="img"
              aria-label="Secure AI architecture diagram: an AI agent connects through the TyCloud LLM-Proxy into a MicroVM agent sandbox behind an isolation boundary"
            >
              <path className="flow" d="M230 64 V108" />
              <path className="flow" d="M230 152 V240" />

              <text className="flow-label" x="244" y="90">tls · authenticated</text>
              <text className="flow-label" x="244" y="200">sandboxed · per-session</text>

              <rect className="iso" x="70" y="212" width="320" height="104" rx="12" />
              <text className="iso-label" x="88" y="236">isolation boundary</text>

              <g className="node n1">
                <rect x="155" y="20" width="150" height="44" rx="10" />
                <text className="node-title" x="230" y="40">AI Agent</text>
                <text className="node-sub" x="230" y="55">untrusted requests</text>
              </g>
              <g className="node n2">
                <rect x="135" y="108" width="190" height="44" rx="10" />
                <text className="node-title" x="230" y="128">TyCloud LLM-Proxy</text>
                <text className="node-sub" x="230" y="143">auth · policy · audit</text>
              </g>
              <g className="node n3">
                <rect x="145" y="248" width="170" height="48" rx="10" />
                <text className="node-title" x="230" y="270">MicroVM</text>
                <text className="node-sub" x="230" y="285">agent sandbox</text>
              </g>
            </svg>
          </div>

          <a
            href={IQ_LISTING}
            target="_blank"
            rel="noopener noreferrer"
            className="hero-badge"
          >
            <img src={APN_BADGE} alt="AWS Select Consulting Partner badge" />
            <div>
              <strong>AWS Select Consulting Partner</strong>
              <span>★★★★★ rated on AWS IQ</span>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Splash;
